import type { Control, FieldPath, FieldPathValue, FieldValues } from 'react-hook-form';

import { isFunction } from '@enonic/js-utils/value/isFunction';


export type WatchWithNameParams<
	TFieldValues extends FieldValues = FieldValues,
	TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
	name: TFieldName;
	// defaultValue?: FieldPathValue<TFieldValues, TFieldName>;
	control?: Control<TFieldValues>;
	// disabled?: boolean;
	// exact?: boolean;
};

export type UseWatchWithName<
	TFieldValues extends FieldValues = FieldValues,
	TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = (props: WatchWithNameParams<TFieldValues, TFieldName>) => FieldPathValue<TFieldValues, TFieldName>;

export type ShowIfFunction<
	TFieldValues extends FieldValues = FieldValues,
> = (showIfParams: {
	watch: UseWatchWithName<TFieldValues, FieldPath<TFieldValues>>;
}) => boolean;

export function isShowIfFunction<
	TFieldValues extends FieldValues = FieldValues,
>(showIf: unknown): showIf is ShowIfFunction<TFieldValues> {
	return isFunction(showIf);
}
